import { IonButton, IonSpinner } from "@ionic/react";

// import { FaCanadianMapleLeaf } from "react-icons/fa";
// export const CanadianButton = ({ type = "button", children, onClick, loading = false }) => {
//   return (
//     <button type={type} onClick={onClick} className="canadian-button">
//       <div className="stripe-red-1"></div>
//       <div className="stripe-white">
//         {loading ? <IonSpinner name="dots" color="danger" /> : <span>{children}</span>}
//       </div>
//       <div className="stripe-red-2"></div>
//     </button>
//   );
// };

export const CanadianButton = ({
  type,
  children,
  onClick,
  className = "",
  disabled,
}) => {
  return (
    <IonButton
      type={type}
      onClick={onClick}
      className={`canadian-button poetsen ${className}`}
      disabled={disabled}
    >
      <div className="canadian-button-content">
        <div className="stripe-red-1"></div>
        <div className="stripe-white">
          {/* <FaCanadianMapleLeaf size={20} /> */}
          <span>{children}</span>
        </div>
        <div className="stripe-red-2"></div>
      </div>
    </IonButton>
  );
};

export const CanadianButtonSmall = ({ type, children, onClick, disabled }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className="c-button poetsen"
      disabled={disabled}
    >
      {/* <FaCanadianMapleLeaf /> */}
      {children}
    </button>
  );
};

